<template>
  <div>
    <el-form ref="advertising-format" :model="form" :rules="rules" label-position="top" label-width="120px">
      <el-row>
        <el-form-item label="品牌名与LOGO" prop="brandName">
          <el-row :gutter="20">
            <el-col :span="4" class="logo">
              <gj-image
                v-if="form.brandLogoUrl"
                :src="form.brandLogoUrl"
                :size="80"
              ></gj-image>
              <div class="upload-logo" v-else @click="editLogo">
                <i class="el-icon-plus"></i>
              </div>
              <span class="editLogo" v-if="form.brandLogoUrl" @click="editLogo">修改Logo</span>
            </el-col>
            <el-col :span="20">
              <gj-input width="100%" v-model="form.brandName" maxlength="30" show-word-limit></gj-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="商品" prop="asins">
          <div class="commodity">
            <div class="commodity-title">
              <span>已添加{{ form.asins.length }}个商品（最多可选3个）</span>
              <gj-button type="text" class="opt" :disabled="form.asins.length == 0" @click="delCommodity('', 'all')">全部移除</gj-button>
            </div>
            <div class="commodity-main">
              <div class="commodity-cell" v-for="(item, index) in asinsMap" :key="index">
                <el-row>
                  <el-col :span="2" class="cell-left">{{ index + 1 }}</el-col>
                  <el-col :span="22" class="cell-right" v-if="!item.asin">
                    <div @click="addCommodity(index, 'all')">
                      <i class="el-icon-plus"></i>
                    </div>
                  </el-col>
                  <el-col :span="22" class="selected" v-else>
                    <div class="img">
                      <gj-image size="60" :src="item.imageUrl"></gj-image>
                    </div>
                    <div class="main">
                      <gj-tooltip
                        :text-line="1"
                        :content="item.title">
                        {{item.title | defaultShow}}
                      </gj-tooltip>
                      <el-row>
                        <el-col :span="12">
                          <span style="font-weight: 500;">ASIN：</span>{{item.asin | defaultShow}}
                        </el-col>
                        <el-col :span="12">
                          <span style="font-weight: 500;">FBA库存：</span>{{item.fba | defaultShow}}
                        </el-col>
                        <el-col :span="24" style="padding-top: 5px">
                          <span style="font-weight: 500;">MSKU：</span>{{item.msku | defaultShow}}
                        </el-col>
                      </el-row>
                    </div>
                    <div class="add">
                      <gj-button type="text" class="opt" @click="delCommodity(index, 'item')">移除</gj-button>
                      <gj-button type="text" class="opt" @click="addCommodity(index, 'item')">替换</gj-button>
                    </div>
                    <div></div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item prop="headline">
          <template #label>
            <span style="padding-right: 8px">标题</span>
            <el-popover placement="right" popper-class="standard-list" title="亚马逊审核标准" width="200" trigger="hover">
              <gj-button type="text" slot="reference">查看亚马逊审核标准</gj-button>
              <div class="popover-main" v-for="(sign, signI) in standardList" :key="signI">
                <div class="main-title">{{ sign.title }}</div>
                <div class="main-cell" v-for="(item, index) in sign.list" :key="index">{{ item }}</div>
              </div>
            </el-popover>
          </template>
          <gj-textarea
              v-model="form.headline"
              :styles="{ height: '60px', fontSize: '12px' }"
              placeholder="请输入标题"
              maxlength="50" show-word-limit>
          </gj-textarea>
        </el-form-item>
      </el-row>
      <!-- <el-row class="custom-picture-main">
        <span class="custom-picture">自定义图片</span>
        <el-checkbox v-model="checked">在支持的投放位置中展示自定义图片</el-checkbox>
      </el-row> -->
    </el-form>
  </div>
</template>

<script>
import PopupCommodity from "@/views/modules/ad/sb/common/modal/add/common/popup-commodity"
import { opTypeMixin } from "@/minxins";
import { getAsset } from "@/api/ad"
export default {
  name: '',
  inject: ['getForms', 'anchorRoll', 'getPublicObj'],
  mixins: [opTypeMixin],
  props: {},
  data() {
    return {
      addBase: {},
      addAdvertisingFormat: {},
      form: {},
      rules: {
        brandName: [
          { required: true, message: '请填写品牌名称', trigger: ['blur', 'change']}
        ],
        asins: [
          { required: true, message: '请选择商品', trigger: ['change']}
        ],
        headline: [
          { required: true, message: '请填写标题', trigger: ['blur', 'change']}
        ]
      },
      standardList: [
        {
          title: "审核关键提示",
          list: [
            "避免使用不允许的词语，如“最佳”或“最畅销”；",
            "广告字母全部大写、拼写错误和标点怪异可能会导致您的广告活动被拒绝。确保语法、标点符号、拼写和大写形式正确无误。标题要以大写字母开始，但不要全部采用大写或混合使用大小写。如果品牌名为全部大写则可以例外处理。",
            "确保您的品牌logo位于您的广告中，以便买家能够识别您是广告主；",
            "包含唯一的相关标题，例如质量或关键商品属性；",
            "如果标题中有提及季节性时间（如情人节、圣诞节），广告活动的开始日期与结束日期合理。"
          ]
        },
        {
          title: "关键词审核",
          list: [
            "相关性低的关键词",
            "亚马逊设备（kindle、fire等）名称或亚马逊自营商品及服务名称",
            "可能引起用户不适的关键词",
            "普遍使用的关键词（如：受欢迎、热点、男性、女性、便宜等）",
            "与事实不符的关键词（如：对非免费送货商品设置“免费送货”等）",
          ]
        },
        {
          title: "标题审核",
          list: [
            "标题不要仅罗列单词与短语，建议写成句子",
            "对于自发售起6个月以内的商品可以使用“新”“新产品”“new”等时间优势性表达，在标题中明确记载发售日期",
            "标题中使用“！”或“？”符号时，最多只可使用其中一个",
            "标题中不能使用“♪”等符号或字符表情",
            "标题中不能使用连续空格",
          ]
        }
      ]
    };
  },
  components: {},
  computed: {
    asinsMap() {
      let asins = []
      asins[0] = this.form.asinsItem[0] || {}
      asins[1] = this.form.asinsItem[1] || {}
      asins[2] = this.form.asinsItem[2] || {}
      return asins
    },
    publicObj() {
      return this.getPublicObj()
    }
  },
  methods: {
    // 修改logo
    editLogo() {
      if (!this.addBase.brandEntityId) {
        this.anchorRoll("#id1")
        this.$message.warning('请先填写基础信息中的品牌！')
        return false
      }
      this.$gjCreate("gj-upload-img", {
        props: {
          title: "修改Logo",
          marketId: this.publicObj.SB.marketId,
          brandEntityId: this.addBase.brandEntityId,
          specifications: {
            title: "商标要求：",
            list: [
              "尺寸至少为400*400像素",
              "文件大小小于1MB",
              "文件格式为PNG，JPEG或GIF",
              "商标必须填充图片，白色背景或者透明背景",
            ]
          }
        },
        on: {
          update: (data) => {
            this.form.brandLogoAssetID = data.assetID
            let params = {
              marketId: this.publicObj.SB.marketId,
              brandEntityId: this.addBase.brandEntityId,
              assetId: this.form.brandLogoAssetID
            }
            // 获取图片信息
            getAsset(params).then(({ data }) => {
              this.form.brandLogoUrl = data.url
            })
          }
        }
      });
    },
    // 移除商品
    delCommodity(index, type) {
      const opt = {
        all: () => {
          this.form.asins = []
          this.form.asinsItem = []
        },
        item: () => {
          this.$set(this.form.asins, index, "")
          this.$set(this.form.asinsItem, index, {})
        },
      }
      opt[type]()
    },
    // 添加商品
    async addCommodity(index, type) {
      let tableDataProps = null
      let pageUrl = null
      if (this.addAdvertisingFormat.adFormatUrl == 0) {
        pageUrl = this.addAdvertisingFormat.landingPage.url
      }else {
        tableDataProps = this.addAdvertisingFormat.landingPage.asinsItem
      }
      this.$gjCreate(PopupCommodity, {
        props: {
          marketId: this.publicObj.SB.marketId,
          tableDataProps,
          pageUrl,
          selectValue: this.form.asins,
          maxNumber: type == 'all' ? 3 - this.form.asins.filter(e => e).length : 1
        },
        on: {
          update: (row) => {
            if (type == 'all') {
              let asinsItem = this.form.asinsItem
                .filter(e => e.asin)
                .concat(row)
              this.delCommodity('', 'all')
              this._.uniqBy(asinsItem, 'asin').forEach((e, i) => {
                this.$set(this.form.asins, i, e.asin)
                this.$set(this.form.asinsItem, i, e)
              });
            }else {
              if (this.form.asins.includes(row[0].asin)) return this.$message.error("请勿重复添加商品")
              this.$set(this.form.asins, index, row[0].asin)
              this.$set(this.form.asinsItem, index, row[0])
            }
          }
        }
      });
    },
  },
  created() {
    let { addBase, creative, addAdvertisingFormat } = this.getForms()
    this.form = creative
    this.addAdvertisingFormat = addAdvertisingFormat
    this.addBase = addBase
  },
};
</script>

<style scoped lang='scss'>
/deep/.el-form-item__label {
  line-height: 1;
  padding-bottom: 12px;
}
/deep/.el-button.el-button--text.el-button--small.el-popover__reference {
  padding: 0 !important;
}
.upload-logo {
  width: 80px;
  height: 80px;
  border: 1px dashed #C0C4CC;
  border-radius: 3px;
  color: #999;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    border: 1px dashed #999;
    color: #666;
  }
}
/deep/.gj-image {
  width: 81px;
  height: 81px;
}
/deep/.gj-image-uploader-icon {
  width: 81px !important;
  height: 81px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
.logo {
  position: relative;
  .editLogo {
    position: absolute;
    bottom: -6px;
    right: -63px;
    cursor: pointer;
    color: #1F6EEF;
  }
}
.commodity {
  border: 1px solid #eee;
  .commodity-title {
    height: 30px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #333;
    border-bottom: 1px solid #eee;
    background: rgba(240,244,248,0.60);
    font-size: 12px;
    .remove {
      color: #999;
      cursor: pointer;
    }
  }
  .commodity-main {
    .commodity-cell {
      line-height: 1;
      height: 74px;
      border-bottom: 1px solid #eee;
      color: #999;
      .cell-left {
        line-height: 74px;
        text-align: center;
        border-right: 1px solid #eee;
      }
      .cell-right {
        cursor: pointer;
        line-height: 74px;
        text-align: center;
        font-size: 18px;
      }
      .selected {
        display: flex;
        height: 74px;
        align-items: center;
        font-size: 12px;
        line-height: 14px;
        color: #666;
        .img {
          padding: 0 12px;
        }
        .main {
          flex: 1;
        }
        .add {
          padding: 0 18px;
          cursor: pointer;
          color: #5d9bfc;
          .opt {
            display: block;
            margin: 0;
          }
        }
        /deep/.el-tooltip {
          margin-bottom: 5px;
        }
      }
      &:last-child {
        border: none;
      }
    }
  }
}
.custom-picture-main {
  padding-bottom: 25px;
  .custom-picture {
    font-size: 12px;
    padding-right: 8px;
    font-weight: 500;
  }
}

  .el-popover__title {
    font-size: 14px;
    color: #eee;
  }
  .popover-main {
    padding: 0 15px;
    .main-title {
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      transform: translateX(-12px);
      padding:5px 0 12px;
    }
    .main-cell {
      font-size: 12px;
      position: relative;
      padding-bottom: 8px !important;
      &::before {
        content: "";
        position: absolute;
        width: 5px;
        height: 5px;
        background: #999;
        border-radius: 100%;
        top: 6px;
        left: -12px;
      }
    }
  }
</style>